"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportFormatSchema = void 0;
const enum_schema_1 = require("./enum.schema");
const ExportFormat_1 = require("../export/ExportFormat");
exports.exportFormatSchema = (0, enum_schema_1.enumSchema)(ExportFormat_1.ExportFormat);
//# sourceMappingURL=exportFormat.schema.js.map